import React from 'react';

import ErrorPage from '@/components/pages/error-page';

const DefaultStaticLayout: (props: any) => JSX.Element = (): JSX.Element => {
    return <ErrorPage statusCode={404} />;
};

export default DefaultStaticLayout;
